import React, { useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { CampaignProps } from './types/propTypes';

const validationSchema = Yup.object().shape({
  offeredProductsServices: Yup.string().required('Please enter your services'),
  competitiveAdvantages: Yup.string().required('Please enter your competitive advantages'),
  offers: Yup.string().required('Please enter your offers'),
  serviceDescription: Yup.string().required('Please provide an explanation'),
});

const ProductServiceForm: React.FC<CampaignProps> = ({
  setCampaignData,
  campaignData,
  setIsStepValid,
}) => {
  return (
    <div className="my-8 p-6 border border-[#E5E7E7] rounded-2xl">
      <div className="max-w-2xl mx-auto">
        <h2 className="text-[28px] text-center font-semibold font-inter text-black mb-10">
          Now tell us about your product(s) / service(s)
        </h2>

        <Formik
          initialValues={{
            offeredProductsServices: campaignData.offeredProductsServices || '',
            competitiveAdvantages: campaignData.competitiveAdvantages || '',
            offers: campaignData.offers || '',
            serviceDescription: campaignData.serviceDescription || '',
          }}
          validationSchema={validationSchema}
          onSubmit={values => {
            console.log('Form submitted with values:', values);
          }}
        >
          {({ values, isValid, dirty }) => {
            useEffect(() => {
              setCampaignData(prev => ({
                ...prev,
                ...values,
              }));
              setIsStepValid(isValid && dirty);
            }, [values, setCampaignData, isValid, dirty]);

            return (
              <Form className="space-y-6">
                {/* Services Input */}
                <div>
                  <label className="block text-[#4A4D4F] text-base font-normal font-inter mb-2">
                    What product(s) / service(s) do you offer?
                  </label>
                  <Field
                    type="text"
                    name="offeredProductsServices"
                    placeholder="Enter services"
                    className="w-full px-4 py-2 border rounded-lg placeholder-grayscale-600 text-base font-inter font-normal outline-none"
                  />
                  <ErrorMessage
                    name="offeredProductsServices"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>

                {/* Advantages Input */}
                <div>
                  <label className="block text-[#4A4D4F] text-base font-normal font-inter mb-2">
                    Please talk about any competitive advantage(s) you have
                  </label>
                  <Field
                    type="text"
                    name="competitiveAdvantages"
                    placeholder="Enter advantages"
                    className="w-full px-4 py-2 border rounded-lg placeholder-grayscale-600 text-base font-inter font-normal outline-none"
                  />
                  <ErrorMessage
                    name="competitiveAdvantages"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>

                {/* Offers Input */}
                <div>
                  <label className="block text-[#4A4D4F] text-base font-normal font-inter mb-2">
                    Do you provide any offers? If so, what are they and for what period?
                  </label>
                  <Field
                    type="text"
                    name="offers"
                    placeholder="Enter offers"
                    className="w-full px-4 py-2 border rounded-lg placeholder-grayscale-600 text-base font-inter font-normal outline-none"
                  />
                  <ErrorMessage
                    name="offers"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>

                {/* Explanation Input */}
                <div>
                  <label className="block text-[#4A4D4F] text-base font-normal font-inter mb-2">
                    Please give a short explanation of the services, the customer problems, and how
                    you solve it.
                  </label>
                  <Field
                    as="textarea"
                    name="serviceDescription"
                    placeholder="Write explanation"
                    className="w-full px-4 py-2 border rounded-lg placeholder-grayscale-600 text-base font-inter font-normal outline-none"
                    rows={4}
                  />
                  <ErrorMessage
                    name="serviceDescription"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default ProductServiceForm;
